import Customer from '@outdoor-voices/ui/dist/utils/Customer';
import Storage from '@outdoor-voices/ui/dist/utils/Storage';
import ReactDOM from 'react-dom';
import { COOKIES } from '../../config/constants';
import DoerFlag from '../../components/DoerFlag'; // check for doer shopping experience

import { jsx as _jsx } from "react/jsx-runtime";

var doers = function doers() {
  var _window = window,
      OV = _window.OV;
  var navWrap = document.querySelector('.ov-nav-wrap');
  var storage = new Storage();
  var urlParams = new URLSearchParams(window.location.search);
  var paramHandle = urlParams.get('doer');

  if (paramHandle) {
    storage.set(COOKIES.DOER_HANDLE, paramHandle);
  }

  var handle = storage.get(COOKIES.DOER_HANDLE);

  if (!handle) {
    return;
  }

  var CUSTOMER = OV.CUSTOMER;
  var customer = new Customer();
  var numPurchases = customer.getNumberOfPurchases();

  if (numPurchases > 0 && CUSTOMER.loggedIn) {
    storage.remove(COOKIES.DOER_FLAG_CLOSED);
    storage.remove(COOKIES.DOER_HANDLE);
    storage.remove(COOKIES.PROMO);
    return;
  }

  var doerFlag = document.createElement('div');
  doerFlag.id = 'doer-flag';

  if (navWrap) {
    navWrap.appendChild(doerFlag);
    ReactDOM.render( /*#__PURE__*/_jsx(DoerFlag, {
      handle: handle
    }), doerFlag);
  }
};

export default doers;